import { FormlyFieldConfig } from '@ngx-formly/core';

import { ISnAutocompleteTemplateOptions } from './autocomplete-template-options.interface';

export interface ISnAutocompleteFormFieldConfig<M = any> extends FormlyFieldConfig {
  type: 'autocomplete';
  templateOptions: ISnAutocompleteTemplateOptions<M>;
}
